import { selectProgramName } from './selectors';

export const programNameIsSupplierPortal = (program) =>
    selectProgramName(program) === 'Supplier Portal' && programIsActive(program);

export const programIsActive = (program) =>
    isDateInRange(program.fromdate, program.todate);

const isDateInRange = (fromDate, toDate) => {
    const now = new Date();
    const from = new Date(fromDate);
    const to = new Date(toDate);

    return now >= from && now <= to;
};
